"use client";
import React, { useState } from "react";
// import { AnnouncementCardProps } from "../../design1/components/AnnouncementCard";
import { GroupHeader } from "../../../ui/Headers";
import Link from "next/link";
// import Button from "../../../ui/Button";
import dayjs from "dayjs";
import Image from "next/image";
import { useCarouselAnnouncements } from "src/app/lib/useCarouselAnnouncement";
import ReactPlayer from "react-player";
import { generateSlugWithId } from "src/app/serverUtils";
import { AnnouncementCard as AnnouncementVariant } from "./SimilarPosts2";
const LatestUpdate: React.FC<{
  header?: React.ReactNode;
}> = ({ header }) => {
  const { emblaRef, canScrollPrev, canScrollNext, emblaApi, announcements } =
    useCarouselAnnouncements();
  return (
    <section className="py-5 pb-16 ">
      <div className="  mx-auto">
        {!header && (
          <GroupHeader
            max={2000}
            subheader="Stay informed with our latest blogs and announcements, offering valuable insights, news, and updates on the real estate market."
            header="Latest Updates and Insights"
          />
        )}

        {header && header}
        <div className="relative wrapper">
          {/* Custom Prev Button */}
          <button
            className={`absolute rotate-180 sm:-left-4  top-[25%] z-10 ${
              canScrollPrev ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollPrev()}
          >
            <ButtonControls />
          </button>
          {/* Embla Carousel */}
          <div className="w-full">
            <div className="embla overflow-hidden" ref={emblaRef}>
              <div className="embla__container relative  flex">
                {announcements.map((announcement, index) => (
                  <div
                    className="embla__slide xs:w-[100%] w-[480px] h-auto select-none pr-8 shrink-0"
                    key={index}
                  >
                    <AnnouncementVariant {...announcement} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Custom Next Button */}
          <button
            className={`absolute top-[25%] -right-4 -sm:right-4 transform  z-10  ${
              canScrollNext ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollNext()}
          >
            <ButtonControls />
          </button>
        </div>

        {/* <Button
          href="/announcements"
          className="w-max mx-auto primary-btn px-8 py-3 block mt-12"
        >
          Explore More
        </Button> */}
      </div>
    </section>
  );
};
export default LatestUpdate;

export const ButtonControls = () => {
  const [hovered, setHovered] = useState(false);
  const bgColor = hovered ? "var(--primary-color)" : "white";
  const color = hovered ? "white" : "var(--primary-color)";
  return (
    <svg
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      className="transition-colors duration-500"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1580_62305)">
        <circle
          cx="24"
          cy="24"
          r="24"
          transform="matrix(-1 0 0 1 58 8)"
          fill={bgColor}
        />
        <path
          d="M28.7344 22.0235C28.6262 21.909 28.5416 21.7743 28.4855 21.6271C28.4293 21.4799 28.4027 21.3231 28.4072 21.1657C28.4116 21.0082 28.447 20.8532 28.5114 20.7094C28.5758 20.5656 28.6679 20.4359 28.7824 20.3277C28.8969 20.2195 29.0315 20.1349 29.1787 20.0788C29.3259 20.0226 29.4827 19.996 29.6402 20.0005C29.7977 20.0049 29.9527 20.0404 30.0965 20.1047C30.2403 20.1691 30.37 20.2612 30.4782 20.3757L40.6722 31.1693C40.8827 31.392 41 31.6868 41 31.9933C41 32.2997 40.8827 32.5945 40.6722 32.8172L30.4782 43.612C30.3707 43.729 30.241 43.8235 30.0967 43.89C29.9524 43.9565 29.7963 43.9936 29.6375 43.9992C29.4788 44.0049 29.3204 43.9789 29.1718 43.9229C29.0231 43.8668 28.8871 43.7818 28.7716 43.6727C28.6561 43.5636 28.5634 43.4326 28.4989 43.2874C28.4344 43.1422 28.3994 42.9857 28.396 42.8268C28.3925 42.668 28.4206 42.51 28.4787 42.3621C28.5368 42.2143 28.6237 42.0794 28.7344 41.9654L38.1513 31.9933L28.7344 22.0235Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1580_62305"
          x="0"
          y="0"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1580_62305"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1580_62305"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export interface AnnouncementCardProps {
  title: string;
  id?: string | number | undefined;
  description: string;
  image: string;
  buttonText?: string;
  videoLink?: string;
  createdAt?: string;
}

const placeholderBlur =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSIjZTBkMGQwIi8+Cjwvc3ZnPg==";

const isYouTube = (url?: string) =>
  url && (url.includes("youtube.com") || url.includes("youtu.be"));

const isBitChute = (url?: string) => url && url.includes("bitchute.com");

export const AnnouncementCard: React.FC<AnnouncementCardProps> = ({
  title,
  description,
  image,
  id,
  videoLink,
  createdAt,
}) => {
  const hasImage = Boolean(image);
  const hasVideo = !hasImage && Boolean(videoLink);
  const slugwithid = generateSlugWithId(Number(id), title);

  const formattedDate = createdAt
    ? dayjs(createdAt).format("MMMM DD, YYYY")
    : "";

  return (
    <Link
      href={`/announcements/${slugwithid}`}
      className="w-full max-w-[480px] block text-secondary-main overflow-hidden rounded-lg"
    >
      <div className="w-full h-[18rem] relative rounded-t-sm overflow-hidden">
        {hasImage ? (
          <Image
            height={300}
            width={300}
            loading="lazy"
            src={image!}
            alt={title}
            className="w-full h-full object-cover"
            placeholder="empty"
          />
        ) : hasVideo && isYouTube(videoLink) ? (
          <ReactPlayer
            url={videoLink}
            width="100%"
            height="100%"
            controls
            style={{ objectFit: "cover" }}
          />
        ) : hasVideo && isBitChute(videoLink) ? (
          <iframe
            width="100%"
            height="100%"
            src={videoLink?.replace("/video/", "/embed/")}
            title={title}
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        ) : (
          <Image
            height={300}
            width={300}
            loading="lazy"
            src="/images/not-found-2.webp"
            alt="No preview available"
            className="w-full h-full object-cover"
            placeholder="blur"
            blurDataURL={placeholderBlur}
          />
        )}
      </div>

      <div className="py-3 flex flex-col gap-2">
        {formattedDate && (
          <div className="text-sm text-gray-500">{formattedDate}</div>
        )}
        <h3 className="h4 line-clamp-2 text-secondary-main overflow-hidden text-ellipsis">
          {title}
        </h3>
        <p
          className="text-sm"
          dangerouslySetInnerHTML={{
            __html:
              description.length > 250
                ? `${description.slice(0, 250)}...`
                : description,
          }}
        />
      </div>
    </Link>
  );
};

export const GreaterThan = () => {
  return (
    <svg
      width="11"
      height="18"
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.393229 2.07206C0.318048 1.9925 0.259274 1.89891 0.220261 1.79664C0.181248 1.69436 0.16276 1.5854 0.165855 1.47599C0.168951 1.36657 0.193567 1.25883 0.238299 1.15893C0.283032 1.05902 0.347004 0.968905 0.426563 0.893723C0.506123 0.818541 0.599711 0.759766 0.701985 0.720753C0.804259 0.68174 0.913215 0.663254 1.02263 0.666349C1.13205 0.669444 1.23979 0.694061 1.33969 0.738793C1.4396 0.783525 1.52972 0.847497 1.6049 0.927057L8.68823 8.42706C8.83451 8.58178 8.91602 8.78663 8.91602 8.99956C8.91602 9.21248 8.83451 9.41733 8.68823 9.57206L1.6049 17.0729C1.53021 17.1542 1.44012 17.2198 1.33984 17.266C1.23957 17.3122 1.13112 17.338 1.02079 17.3419C0.910463 17.3459 0.800455 17.3278 0.697158 17.2889C0.593861 17.2499 0.499332 17.1908 0.419065 17.115C0.338799 17.0392 0.274391 16.9482 0.229587 16.8473C0.184781 16.7464 0.160471 16.6376 0.158067 16.5273C0.155663 16.4169 0.175214 16.3072 0.215584 16.2044C0.255954 16.1016 0.316339 16.0079 0.393229 15.9287L6.93656 8.99956L0.393229 2.07206Z"
        fill="white"
      />
    </svg>
  );
};
